import { __decorate } from "tslib";
import { Directive, ElementRef, HostListener, Output, EventEmitter } from '@angular/core';
let ClickOutsideDirective = class ClickOutsideDirective {
    _elementRef;
    constructor(_elementRef) {
        this._elementRef = _elementRef;
    }
    clickOutside = new EventEmitter();
    onMouseDown(targetElement) {
        const clickedInside = this._elementRef.nativeElement.contains(targetElement);
        if (!clickedInside) {
            this.clickOutside.emit(null);
        }
    }
    static ctorParameters = () => [
        { type: ElementRef }
    ];
    static propDecorators = {
        clickOutside: [{ type: Output, args: ['appClickOutside',] }],
        onMouseDown: [{ type: HostListener, args: ['document:click', ['$event.target'],] }]
    };
};
ClickOutsideDirective = __decorate([
    Directive({
        standalone: false,
        selector: '[appClickOutside]'
    })
], ClickOutsideDirective);
export { ClickOutsideDirective };
